import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { isPartialDate, partialDateToValue } from 'neuro-utils';
import { formatPartialDate } from 'Utility/date';

import TileContentMaker from 'Components/DashboardTile/TileContentMaker';
import { sortDocumentsDescending } from 'Utility/documentHandling';

const fm = (id: string, values?: { [key: string]: string | number | null }): React.JSX.Element => (
  <FormattedMessage id={id} values={values} />
);

const RelapseDash = ({ documents }: IOwnProps): React.JSX.Element => {
  const sortedDocuments = documents.toSorted(sortDocumentsDescending);
  const latestRelapse = sortedDocuments.at(0);

  const relapses12Months = sortedDocuments.filter(d => {
    if (!d.startDate || !isPartialDate(d.startDate)) return false;
    const thisDate = new Date();
    const date12MonthsAgo = thisDate.setFullYear(thisDate.getFullYear() - 1);
    return partialDateToValue(d.startDate) > date12MonthsAgo.valueOf();
  });

  return (
    <>
      <TileContentMaker
        type="recentListMultipleRows"
        itemsCanFitAmount={1}
        data={
          latestRelapse
            ? [
                {
                  date: isPartialDate(latestRelapse.startDate) ? formatPartialDate(latestRelapse.startDate) : '',
                  title: (
                    <div
                      style={{
                        maxHeight: '12rem',
                        overflow: 'hidden',
                      }}
                    >
                      {Array.isArray(latestRelapse.symptoms) && latestRelapse.symptoms.length > 0 ? (
                        <>
                          <span style={{ fontWeight: 600 }}>
                            <FormattedMessage
                              id="relapse.additionalSymptoms"
                              values={{ n: Number(latestRelapse.symptoms.length) }}
                            />
                            :
                          </span>{' '}
                          <span style={{ fontWeight: 400 }}>
                            {latestRelapse.symptoms.map((item, i) => (
                              <React.Fragment key={item}>
                                {fm(`relapse.symptoms.opts.${item}`)}
                                {`${i < (latestRelapse.symptoms ?? []).length - 1 ? ', ' : ''}`}
                              </React.Fragment>
                            ))}
                          </span>
                        </>
                      ) : null}
                    </div>
                  ),
                  key: 'lastRelapse',
                },
              ]
            : []
        }
      />

      <TileContentMaker
        type="specificListNoDate"
        data={[
          { title: fm(`relapse.relapses12Months`), key: '12months', value: relapses12Months.length },
          { title: fm(`relapse.relapsesAll`), key: 'allRelapses', value: sortedDocuments.length },
        ]}
      />
    </>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'relapse'>[];
}

export default RelapseDash;
